<template>
  <div>
    <Header :self="self" />
    <div class="container quote-view">
      <div class="alert alert-danger" role="alert" v-if="error">
        {{error.message}}
      </div>
      <p class="text-center gqp-header" v-if="!self.isPro">Like Quozio? You'll ❤️ Quozio Pro! <router-link :to="{name: 'get-quozio-pro', query: {ref: 'VBI'}}">Check it out</router-link>.</p>
      <div class="quote-view-image-panel text-center small-scroll">
        <img :src="boardItem.imageUrls.large" @dblclick="toggleExpand()" id="quote-view-image" />
      </div>
      <div class="m-2 text-center">
        <div class="d-flex justify-content-center">
          <i class="fab fa-pinterest-square fa-2x pinterest m-1" @click="shareToPinterest()" v-if="!boardItem.board.private" title="Share to Pinterest"></i>
          <i class="fab fa-facebook-square fa-2x facebook m-1" @click="shareToFacebook()" v-if="!boardItem.board.private" title="Share to Facebook"></i>
          <i class="fab fa-twitter-square fa-2x twitter m-1" @click="shareToTwitter()" v-if="!boardItem.board.private" title="Share to Twitter"></i>
          <!--<button class="btn btn-secondary btn-sm m-1 btn-quote-action" v-b-modal.modal-send-by-email v-if="self.userId" title="Send by Email"><i class="fas fa-envelope"></i><span class="d-none d-sm-inline"> Send</span></button>-->
          <!--<button class="btn btn-secondary btn-sm m-1 btn-quote-action" v-b-modal.modal-create-account-send-email v-if="!self.userId" title="Send by Email"><i class="fas fa-envelope"></i><span class="d-none d-sm-inline"> Send</span></button>-->
          <button class="btn btn-secondary btn-sm m-1 btn-quote-action" v-b-modal.modal-download v-if="self.userId"><i class="fas fa-cloud-download-alt"></i> Download</button>
          <button class="btn btn-success btn-sm m-1 btn-quote-action" @click="openSave()" v-if="self.userId"><i class="fas fa-copy" title="Save to a Board"></i> Save</button>
          <button class="btn btn-success btn-sm m-1 btn-quote-action" v-if="!self.userId" v-b-modal.modal-create-account-save-quote><i class="fas fa-copy" title="Save to a Board"></i> Save</button>
          <button class="btn btn-secondary btn-sm m-1 btn-quote-action" v-if="self.userId == boardItem.userId" title="Add a Caption" @click="showCaptionEdit = !showCaptionEdit"><i class="far fa-comment"></i></button>
        </div>
      </div>
      <div class="text-center mb-2">
        <button class="btn btn-primary btn-primary btn-pill" @click="makeYourOwn()">Make Your Own Quote</button>
      </div>
      <div class="mt-3 mb-3 caption" v-if="boardItem.caption && !showCaptionEdit">
        <strong><nuxt-link :to="{ name: 'username', params: { username: boardItem.user.username } }">{{boardItem.user.name}}</nuxt-link></strong><br />
        <span class="caption-text" v-html="boardItem.caption"></span>
      </div>
      <div v-if="showCaptionEdit">
        <div class="form-group mb-1">
          <textarea v-model="boardItem.caption" class="form-control caption" placeholder="Share a bit more about this quote or why it's meaningful to you" v-resizable></textarea>
        </div>
        <div class="form-group text-right">
          <button class="btn btn-primary" @click="saveCaption()">Save</button>
        </div>
      </div>
      <div class="m-2">
        <p class="quote" v-show="boardItem.quote">"{{boardItem.quote}}"</p>
        <p class="author" v-show="boardItem.author">- {{boardItem.author}}</p>
      </div>
      <div class="user-info">Saved by <nuxt-link :to="{ name: 'username', params: { username: boardItem.user.username } }">@{{boardItem.user.username}}</nuxt-link> to <nuxt-link :to="{ name: 'board-boardId-boardSlug', params: { boardId: boardItem.board.boardId, boardSlug: boardItem.board.slug } }">{{boardItem.board.name}}</nuxt-link></div>
      <div v-if="boardItem.template.attributionProvider" class="attribution">Background image by <a :href="boardItem.template.attributionUrl" target="_blank">{{boardItem.template.attributionName}}</a> on <a :href="boardItem.template.attributionProviderUrl" target="_blank" class="text-capitalize">{{boardItem.template.attributionProvider}}</a></div>
      <div class="text-right">
        <button class="btn btn-danger btn-sm m-1" v-b-modal.modal-confirm-delete v-if="self.userId == boardItem.userId || self.userId == boardItem.board.userId" title="Delete"><i class="fas fa-trash-alt"></i></button>
      </div>
    </div>

    <b-modal id="modal-board-select" scrollable>
      <div class="alert alert-danger" role="alert" v-if="modalError">
        {{modalError.message}}
      </div>
      <template v-slot:modal-title>
        Where do you want to save it?
      </template>
      <div class="" v-if="!showCreateBoard">
        <div class="boards-select-wrapper justify-content-left">
          <div class="text-center mb-2">
            <button class="btn btn-primary btn-success btn-pill" @click="showCreateBoard = true">Create New Board</button>
          </div>
          <div v-for="(board, index) in boards.data" class="board-select-wrapper pointer" @click="copy(board.boardId)">
            <div class="board-select-icon">
              <img :src="board.previewImageUrls.square" />
            </div>
            <div class="board-select-text">
              {{board.name}}
              <div class="sub text-secondary">
                <span>{{board.itemCount}} <span v-if="board.itemCount === 1">Quote</span><span v-if="board.itemCount !== 1">Quotes</span></span>
                <span v-if="board.private" title="This board is private">&nbsp;<i class="fas fa-lock"></i></span>
                <span v-if="board.hidden && !board.private" title="This board is hidden">&nbsp;<i class="fas fa-eye-slash"></i></span>
                <span v-if="board.userCount > 1" title="This is a group board">&nbsp;<i class="fas fa-user-friends"></i></span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="showCreateBoard">
        <h5>Create a new board</h5>
        <div class="form-group" v-bind:class="{ 'form-group-error': $v.newBoard.name.$error }">
          <label for="name">Name</label>
          <input type="text" v-model.trim.lazy="$v.newBoard.name.$model" class="form-control" id="name" placeholder="What do you want to call this board?">
          <div class="error-input">Please provide a name</div>
        </div>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" id="private" v-model="newBoard.private">
          <label class="form-check-label" for="private">Make this a private board</label>
          <small class="form-text text-muted">Private boards can only be seen and accessed by you and others you invite to the board.</small>
        </div>
        <div class="form-check" v-show="!newBoard.private">
          <input type="checkbox" class="form-check-input" id="hidden" v-model="newBoard.hidden">
          <label class="form-check-label" for="hidden">Don't show this board with my profile</label>
          <small class="form-text text-muted">Others will be able to access this board, but it will not be listed on your profile page.</small>
        </div>
      </div>
      <template v-slot:modal-footer v-bind:class="{ 'hide-modal-footer': showCreateBoard === false }">
        <div v-if="!showCreateBoard"></div>
        <div class="board-select-footer right pointer" v-if="showCreateBoard">
          <button class="btn btn-light btn-sm mb-2" @click="showCreateBoard = false">Cancel</button>
          <button class="btn btn-success btn-sm ml-2 mb-2" @click="createBoard()"><i class="fas fa-check"></i> Save</button>
        </div>
      </template>
    </b-modal>

    <b-modal id="modal-confirm-delete" title="Remove Quote">
      <p class="text-center"><i class="fas fa-exclamation-triangle fa-5x text-warning"></i></p>
      <p class="my-4">Are you sure you want to remove this quote from the board?</p>
      <template v-slot:modal-footer="{ ok, cancel, hide }">
        <div class="flex-grow-1">
          <button class="btn btn-sm btn-danger" @click="deleteItem()" :disabled="submitting.deleteItem"><i class="fas fa-trash-alt"></i> Yes, Remove</button>
        </div>
        <div>
          <button class="btn btn-primary btn-sm" @click="cancel()">Cancel</button>
        </div>
      </template>
    </b-modal>

    <b-modal id="modal-send-by-email" title="Send Quote">
      <div class="alert alert-danger" role="alert" v-if="modalError">
        {{modalError.message}}
      </div>
      <p class="text-center"><i class="far fa-envelope fa-5x text-primary"></i></p>
      <p class="my-4">
        <div class="form-group">
          <label for="email" class="text-center"><strong>Email Address</strong></label>
          <input type="email" id="email" v-model="sendByEmail.email" class="form-control" placeholder="someone@example.com" />
        </div>
      </p>
      <template v-slot:modal-footer="{ ok, cancel, hide }">
        <div>
          <button class="btn btn-primary btn-sm" @click="sendBoardItemByEmail()" :disabled="submitting.sendBoardItemByEmail">Send</button>
        </div>
      </template>
    </b-modal>

    <b-modal id="modal-create-account-send-email" title="Send Quote" hide-footer>
      <div class="alert alert-danger" role="alert" v-if="modalError">
        {{modalError.message}}
      </div>
      <p class="text-center"><i class="far fa-envelope fa-5x text-primary"></i></p>
      <p class="my-4">
        <h5 class="text-center">Want to send this quote by email?</h5>
      </p>
      <p class="my-4 text-center">
        Join Quozio and email your favorite quotes, save them to your account and more. It's free!
      </p>
      <p class="my-4 text-center">
        <router-link class="btn btn-success btn-lg" :to="{ name: 'join', query: { redirect: getRoutePath() } }">Join Now, It's Free!</router-link>
      </p>
      <p class="my-4 text-center">
        Already have an account? <router-link :to="{ name: 'sign-in', query: { redirect: getRoutePath() } }" v-cloak>Sign In</router-link>.
      </p>
    </b-modal>

    <b-modal id="modal-create-account-save-quote" title="Save Quote" hide-footer>
      <div class="alert alert-danger" role="alert" v-if="modalError">
        {{modalError.message}}
      </div>
      <p class="text-center"><i class="fas fa-file-import fa-5x text-primary"></i></p>
      <p class="my-4">
        <h5 class="text-center">Want to save this quote?</h5>
      </p>
      <p class="my-4 text-center">
        No problem! Join Quozio to keep your favorite quotes in a safe place, making them easy to find, share and download. It's free!
      </p>
      <p class="my-4 text-center">
        <router-link class="btn btn-success btn-lg" :to="{ name: 'join', query: { redirect: getRoutePath() } }">Join Now, It's Free!</router-link>
      </p>
      <p class="my-4 text-center">
        Already have an account? <router-link :to="{ name: 'sign-in', query: { redirect: getRoutePath() } }" v-cloak>Sign In</router-link>.
      </p>
    </b-modal>

    <b-modal id="modal-download" title="Download Quote" @ok="download()">
      <div class="alert alert-danger" role="alert" v-if="modalError">
        {{modalError.message}}
      </div>
      <p class="text-center"><i class="fas fa-cloud-download-alt fa-5x text-primary"></i></p>
      <p class="my-4">
        <h5 class="text-center">What size image would you like to download?</h5>
      </p>
      <p class="my-4">
        <div class="form-check mb-3">
          <input class="form-check-input" type="radio" name="downloadSize" v-model="downloadSize" id="downloadSizeSmall" value="small" @change="setDownloadUrl()">
          <label class="form-check-label" for="downloadSizeSmall">
            Small
          </label>
        </div>
        <div class="form-check mb-3">
          <input class="form-check-input" type="radio" name="downloadSize" v-model="downloadSize" id="downloadSizeMedium" value="medium" @change="setDownloadUrl()">
          <label class="form-check-label" for="downloadSizeMedium">
            Medium
          </label>
        </div>
        <div class="form-check mb-3">
          <input class="form-check-input" type="radio" name="downloadSize" v-model="downloadSize" id="downloadSizeLarge" value="large" @change="setDownloadUrl()">
          <label class="form-check-label" for="downloadSizeLarge">
            Large
          </label>
        </div>
        <div class="form-check mb-3">
          <input class="form-check-input" type="radio" name="downloadSize" v-model="downloadSize" id="downloadSizeMax" value="max" :disabled="!self.isPro" @change="setDownloadUrl()">
          <label class="form-check-label" for="downloadSizeMax">
            Full Size (High Definition / Printable) <span class="badge badge-danger">Pro</span>
          </label>
        </div>
      </p>
      <div v-if="!self.isPro">
        <p class="my-4 text-center">
          Get Quozio Pro and access additional designs, add custom watermarks, download full size images and more!
        </p>
        <p class="my-4 text-center">
          <router-link class="btn btn-success btn-sm" :to="{ name: 'get-quozio-pro', query: { ref: 'DLFSBI' } }">Learn More</router-link>
        </p>
      </div>
      <template v-slot:modal-footer="{ ok, cancel, hide }">
        <div>
          <a class="btn btn-primary btn-sm" v-bind:href="downloadUrl" @click="closeDownloadModal()">Download</a>
        </div>
      </template>
    </b-modal>
    <Footer />
  </div>
</template>

<script>
  import Header from "@/components/header";
  import Footer from "@/components/footer";
  import { mapState } from "vuex";
  import { required } from "vuelidate/lib/validators";

  export default {
    components: { Header, Footer },
    data() {
      return {
        boardItem: {
          imageUrls: {}, downloadUrls: {}, board: {}, template: {},
        },
        boards: { data: [] },
        showCreateBoard: false,
        newBoard: { name: null, private: false, hidden: false },
        showCaptionEdit: false,
        downloadSize: "large",
        downloadUrl: null,
        error: null,
        modalError: null,
        sendByEmail: { email: null },
        submitting: { copy: false, deleteItem: false, createBoard: false, sendBoardItemByEmail: false, saveCaption: false },
      };
    },
    head({ $config }) {
      return {
        title: `${this.boardItem.name} - Quozio`,
        link: [
          { rel: 'canonical', href: this.getPageUrl($config.BASE_URL, this.boardItem.boardId, this.boardItem.boardItemId, this.boardItem.slug) }
        ],
        meta: [
          { hid: "og:url", name: "og:url", content: this.getPageUrl($config.BASE_URL, this.boardItem.boardId, this.boardItem.boardItemId, this.boardItem.slug) },
          { hid: "og:title", name: "og:title", content: this.boardItem.name },
          { hid: "og:description", name: "og:description", content: this.boardItem.quote },
          { hid: "og:image", name: "og:image", content: this.boardItem.imageUrls.large }
        ]
      }
    },
    async asyncData({ store, app, params, error, redirect, $config }) {
      await store.dispatch("self/get", app.$cookies);
      let response = await app.$dataService.get(`/boards/${params.boardId}/boardItems/${params.itemId}`, { expand: "board,user,template" });
      if (response.error) {
        return error({ statusCode: response.error.status, message: response.error.message, reference: response.error.reference });
        return;
      }
      return { boardItem: response.data, downloadUrl: `${response.data.downloadUrls["large"]}` };
    },
    async mounted() {
      this.$root.$on("bv::modal::hidden", (bvEvent, modalId) => {
        this.modalError = null;
        this.showCreateBoard = false;
      })
    },
    methods: {
      toggleExpand() {
        let quoteImageEl = document.getElementById("quote-view-image");
        if (quoteImageEl) {
          quoteImageEl.classList.toggle("expanded");
        }
      },
      async copy(boardId) {

        if (this.submitting.copy)
          return;

        this.submitting.copy = true;
        this.$nuxt.$loading.start();
        let response = await this.$dataService.post(`/boards/${this.$route.params.boardId}/boardItems/${this.$route.params.itemId}/copy`, null, { to: boardId, expand: "board" });
        this.submitting.copy = false;
        if (response.error) {
          this.modalError = response.error;
          this.$nuxt.$loading.finish();
          return;
        }

        this.$bvModal.hide("modal-board-select");
        let boardItem = response.data;

        this.$nuxt.$loading.finish();

        this.$ga.event("Quote", "Item Saved", "bi-" + this.$route.params.boardId + "/" + this.$route.params.itemId);

        if (boardItem.boardItemId) {
          let toast = this.$toasted.show("Saved!", {
            theme: "outline",
            position: "bottom-center",
            duration: 5000,
            iconPack: "fontawesome",
            icon: "thumbs-up",
            type: "success",
            keepOnHover: true,
            action: {
              text: 'Take a look',
              onClick: (e, toastObject) => {
                toastObject.goAway(0);
                this.$router.push({ name: "board-boardId-boardSlug", params: { boardSlug: boardItem.board.slug, boardId: boardItem.board.boardId } });
              }
            }
          });
        }
      },
      async deleteItem() {
        this.submitting.deleteItem = true;
        this.$nuxt.$loading.start();
        let response = await this.$dataService.delete(`/boards/${this.$route.params.boardId}/boardItems/${this.$route.params.itemId}`);
        this.submitting.deleteItem = false;
        if (response.error) {
          this.error = response.error;
          this.$nuxt.$loading.finish();
          return;
        }

        this.$nuxt.$loading.finish();
        let toast = this.$toasted.show("The item has been deleted", {
          theme: "outline",
          position: "bottom-center",
          duration: 5000,
          iconPack: "fontawesome",
          icon: "thumbs-up",
          type: "success",
          keepOnHover: false
        });
        this.$router.push({ name: "board-boardId-boardSlug", params: { boardName: this.boardItem.board.slug, boardId: this.boardItem.board.boardId, boardSlug: this.boardItem.board.slug } });
      },
      async createBoard() {
        this.$v.$touch();
        if (this.newBoard.private) {
          this.newBoard.hidden = true;
        }
        if (!this.$v.$invalid) {
          this.submitting.createBoard = true;
          this.$nuxt.$loading.start();
          let response = await this.$dataService.post("/boards", this.newBoard);
          if (response.error) {
            this.error = response.error;
            this.$nuxt.$loading.finish();
            return;
          }
          let board = response.data;
          this.$ga.event("Board", "Board Created", board.boardId, board.private ? 0 : 1);
          await this.copy(board.boardId);
          this.submitting.createBoard = false;
          this.showCreateBoard = false;
          this.newBoard = { name: null, private: false, hidden: false };
          this.$v.$reset();
        }
      },
      async openSave() {
        this.$bvModal.show("modal-board-select");
        if (!this.boards.data.length) {
          let response = await this.$dataService.get("/boards", { includePreviewImages: true });
          if (response.error) {
            this.error = response.error;
            return;
          }
          this.boards = response.data;
        }
      },
      async saveCaption() {
        this.submitting.saveCaption = true;
        this.$nuxt.$loading.start();
        let response = await this.$dataService.put(`/boards/${this.$route.params.boardId}/boardItems/${this.$route.params.itemId}`, this.boardItem);
        this.submitting.saveCaption = false;
        if (response.error) {
          this.error = response.error;
          this.$nuxt.$loading.finish();
          return;
        }
        this.$nuxt.$loading.finish();
        this.showCaptionEdit = false;
      },
      setDownloadUrl() {
        this.downloadUrl = `${this.boardItem.downloadUrls[this.downloadSize]}`;
      },
      closeDownloadModal() {
        setTimeout(() => { this.$bvModal.hide("modal-download"); }, 500);
      },
      async sendBoardItemByEmail() {

        let payload = { email: this.sendByEmail.email };

        this.submitting.sendBoardItemByEmail = true;
        this.$nuxt.$loading.start();
        this.modalError = null;
        let response = await this.$dataService.post(`/boards/${this.$route.params.boardId}/boardItems/${this.$route.params.itemId}/sendByEmail`, payload);
        this.submitting.sendBoardItemByEmail = false;
        if (response.error) {
          this.modalError = response.error;
          this.$nuxt.$loading.finish();
          return;
        }
        this.$bvModal.hide("modal-send-by-email");
        this.sendByEmail.email = null;

        this.$nuxt.$loading.finish();

        this.$ga.event("Social", "Email Sent", "bi-" + this.$route.params.boardId + "/" + this.$route.params.itemId);

        let toast = this.$toasted.show("Sent!", {
          theme: "outline",
          position: "bottom-center",
          duration: 5000,
          iconPack: "fontawesome",
          icon: "thumbs-up",
          type: "success",
          keepOnHover: true,
        });
      },
      getPageUrl(baseUrl, boardId, boardItemId, slug) {
        return `${baseUrl}/item/${boardId}/${boardItemId}/${slug}`;
      },
      shareToFacebook() {
        let shareUrl = this.getPageUrl(this.$config.BASE_URL, this.boardItem.boardId, this.boardItem.boardItemId, this.boardItem.slug);
        let url = `https://www.facebook.com/dialog/share?app_id=${this.$config.FACEBOOK_APP_ID}&display=popup&href=${shareUrl}`;
        let options = "toolbar=0,status=0,resizable=1,width=626,height=436";
        window.open(url, "sharer", options);
        this.$ga.event("Social", "Share - Facebook", "bi-" + this.boardItem.boardId + "/" + this.boardItem.boardItemId);

      },
      shareToTwitter() {
        let maxTweetLength = 257; // 280 max content length minus 23 characters for the URL (provided URL will be shortened)
        let text = this.boardItem.quote.substring(0, 257);

        // Can you fit the author in?
        if (this.boardItem.author && this.boardItem.author.length < maxTweetLength - (text.length + 2)) {
          text = `${text} -${this.boardItem.author}`
        }

        let shareUrl = this.getPageUrl(this.$config.BASE_URL, this.boardItem.boardId, this.boardItem.boardItemId, this.boardItem.slug);
        let url = `https://twitter.com/intent/tweet?text=${text}&url=${shareUrl}`;
        let options = "toolbar=0,status=0,resizable=1,width=550,height=390";
        window.open(url, "tweeter", options);
        this.$ga.event("Social", "Share - Twitter", "bi-" + this.boardItem.boardId + "/" + this.boardItem.boardItemId);
      },
      shareToPinterest() {
        let shareUrl = this.getPageUrl(this.$config.BASE_URL, this.boardItem.boardId, this.boardItem.boardItemId, this.boardItem.slug);
        let text = this.boardItem.author != null ? `${this.boardItem.quote} -${this.boardItem.author}` : this.boardItem.quote;

        // Unsplash requires credit in social media text if their API was used for the quote background.
        if (this.boardItem.template.attributionProvider == "unsplash") {
          text += ` (Image background by ${this.boardItem.template.attributionName} on Unsplash)`;
        }

        let url = `https://www.pinterest.com/pin/create/button/?url=${shareUrl}&media=${this.boardItem.imageUrls.large}&description=${text}`;
        let options = "toolbar=0,status=0,resizable=1,width=800,height=600";
        window.open(url, "pinner", options);
        this.$ga.event("Social", "Share - Pinterest", "bi-" + this.boardItem.boardId + "/" + this.boardItem.boardItemId);
      },
      getRoutePath() {
        return this.$route.path;
      },
      async makeYourOwn() {
        this.$router.push({ name: 'index' });
        this.$ga.event("UIUX", "Make Your Own", "From Board Item");
      },
    },
    computed: {
      ...mapState("self", { self: "self" }),
    },
    directives: {
      resizable: {
        inserted: function (el) {
          el.addEventListener("input", function (e) {
            e.target.style.height = "auto";
            e.target.style.height = (e.target.scrollHeight + 2) + "px";
          });
        }
      }
    },
    validations: {
      newBoard: {
        name: {
          required
        }
      }
    }
  };
</script>
